// @flow

import React, { Component } from "react";
import { scaleLinear } from "d3-scale";
import { Motion, spring } from "react-motion";
// import './Slider.scss';
// import sliderHadleSvg from 'assets/bg_notch.svg';

// Helper to get pageX from either a mouse or touch event
const getPageX = (e: any): number => {
  return e.touches ? e.touches[e.touches.length - 1].pageX : e.pageX;
};

type Props = {
  min: number,
  max: number,
  onChange: (value: number) => void,
  value: number,
  unit: string,
  color: string
};

type State = {
  left?: number,
  width: number | null,
  dragging: boolean
};

export default class Slider extends Component<any, Props, State> {
  slider: HTMLElement;
  scale: any;

  static defaultProps = {
    min: 0,
    max: 100
  };

  state = {
    width: null,
    dragging: false
  };

  componentDidMount() {
    setTimeout(() => {
      const { min, max } = this.props;
      const { left, width } = this.slider.getBoundingClientRect();
      this.scale = scaleLinear()
        .domain([min, max])
        .range([0, width])
        .clamp(true);
      if (document.body) {
        this.setState({ left: left + document.body.scrollLeft, width });
      }
    }, 50);
  }

  handleDragStart = (e: TouchEvent | MouseEvent) => {
    e.preventDefault();
    const { min, max } = this.props;
    const { left, width } = this.slider.getBoundingClientRect();
    const scrollLeft = document.body ? document.body.scrollLeft : 0;

    const x = getPageX(e) - left - scrollLeft;

    // Add global mouse listeners, so dragging outside of the slider keeps working
    // For some reason touch handlers work fine
    if (!e.touches) {
      window.addEventListener("mousemove", this.handleDrag);
      window.addEventListener("mouseup", this.handleDragEnd);
    }

    this.scale.domain([min, max]).range([0, width]).clamp(true);
    this.setState({ dragging: true, left: left + scrollLeft, width });
    this.props.onChange &&
      this.props.onChange(Math.round(this.scale.invert(x)));
  };

  handleDragEnd = () => {
    window.removeEventListener("mousemove", this.handleDrag);
    window.removeEventListener("mouseup", this.handleDragEnd);
    this.setState({ dragging: false });
  };

  handleDrag = (e: MouseEvent) => {
    e.preventDefault();
    if (!this.state.dragging) {
      return;
    }
    const x = getPageX(e) - (this.state.left || 0);
    this.props.onChange(Math.round(this.scale.invert(x)));
  };

  sliderRef = (el: HTMLElement) => {
    this.slider = el;
  };

  render() {
    const { min, max, value, unit, color } = this.props;
    const { width } = this.state;
    const { scale } = this;

    if (width === null) {
      return (
        <div className="Slider" ref={this.sliderRef}>
          <style jsx>{`
          .Slider {
            width: calc(100% - 40px);
            max-width: 420px;
            height: 24px;
            position: relative;
            margin: 50px auto;
          }
        `}</style>
        </div>
      );
    }

    const sliderX = scale(value === null ? (max - min) / 2 : value);

    return (
      <div
        className="Slider"
        ref={this.sliderRef}
        onMouseDown={this.handleDragStart}
        onTouchStart={this.handleDragStart}
        onTouchMove={this.handleDrag}
        onTouchEnd={this.handleDragEnd}
      >
        <div className="Slider-TickLabel" style={{ left: 0 }}>
          {min} {unit}
        </div>
        <div className="Slider-TickLabel" style={{ right: 0 }}>
          {max} {unit}
        </div>
        <Motion
          style={{ val: spring(sliderX, { stiffness: 400, damping: 50 }) }}
        >
          {({ val }) => {
            return (
              <div>
                <div
                  className="Slider-Bar"
                  style={{
                    width: `${val}px`,
                    backgroundColor: color,
                    opacity: value === null ? 0 : 1
                  }}
                />
                <div
                  className="Slider-Handle"
                  style={{
                    transform: `translateX(${val}px)`,
                    WebkitTransform: `translateX(${val}px)`,
                    msTransform: `translateX(${val}px)`
                  }}
                />
                {value !== null &&
                  <div
                    className="Slider-Label"
                    style={{ bottom: 32, left: `${val}px` }}
                  >
                    {value} {unit}
                  </div>}
              </div>
            );
          }}
        </Motion>
        <style jsx>{`
          .Slider {
            background: #fff;
            width: calc(100% - 40px);
            max-width: 420px;
            height: 24px;
            position: relative;
            margin: 50px auto;
            touch-action: manipulation;
          }

          .Slider-Bar {
            transition: opacity 0.2s;
            position: absolute;
            top: 0;
            left: 0;
            height: 24px;
            background: #333;
          }

          .Slider-TickLabel {
            color: #1c1c1c;
            font-family: FrutigerLTCom;
            font-size: 12px;
            position: absolute;
            top: 36px;
          }

          .Slider-Handle {
            box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            width: 22px;
            margin-left: -11px;
            margin-top: -7px;
            height: 38px;
            background: #1c1c1c;
          }

          .Slider-Label {
            transform: translateX(-50%);
            font-family: FrutigerLTCom;
            font-weight: 700;
            position: absolute;
            left: 0;
            text-align: center;
            white-space: nowrap;
          }

          .Slider-SubLabel {
            font-size: 12px;
            font-weight: 500;
          }

          .Slider-Indicator {
            position: absolute;
            top: 0;
            left: 0;
            width: 2px;
            margin-left: -1px;
            height: 24px;
            background: #000;
          }
        `}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Quiz/Slider.js